import { apiService } from "./apiService";
import { INewsResponse, INewsOptions } from "../types/news";

export const NewsService = {
  get: async (options: INewsOptions): Promise<INewsResponse> => {
    return apiService.post("/api/news", { ...options }).then(res => {
      const { data } = res;
      return res.status === 200 && data;
    });
  },
  delete: async (newsId: string) => {
    return apiService.delete(`/api/news/${newsId}`).then(res => res.status && res.status === 200 && res.data && res.data.successful);
  }
};



// WEBPACK FOOTER //
// ./src/share/services/news.ts